import React, { useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { TabBar } from 'common/TabBar';
import { UsersList } from './UsersList';
import { UserGroups } from './UserGroups';
import { UserLabels } from './UserLabels';
import { GlobalAssignment } from 'components/GlobalAssignment';

const tabsItems = [
    { type: 'users', name: 'Users' },
    { type: 'userGroups', name: 'Groups' },
    { type: 'labels', name: 'Labels' },
    // OZNEWS-3131: Routing moved from left menu to a tab under Users
    { type: 'routing', name: 'Routing' },
];

export const Users = () => {
    const [activeView, setActiveView] = useState('users');

    return (
        <Row>
            <Col xs="12">
                <Card>
                    <CardHeader>
                        <div className="flex-space-between">
                            <h1>Users</h1>
                        </div>
                    </CardHeader>
                    <CardBody>
                        <TabBar activeItem={activeView} setActive={setActiveView} items={tabsItems} />
                        {activeView === 'users' && <UsersList />}
                        {activeView === 'userGroups' && <UserGroups />}
                        {activeView === 'labels' && <UserLabels />}
                        {/* OZNEWS-3131: Routing moved from left menu to a tab under Users */}
                        {activeView === 'routing' && <GlobalAssignment embedded onSaved={() => setActiveView('users')} />}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};
